import { render, staticRenderFns } from "./liberacaoautomatica.vue?vue&type=template&id=a06d5112&scoped=true&"
import script from "./liberacaoautomatica.vue?vue&type=script&lang=js&"
export * from "./liberacaoautomatica.vue?vue&type=script&lang=js&"
import style0 from "./liberacaoautomatica.vue?vue&type=style&index=0&id=a06d5112&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06d5112",
  null
  
)

export default component.exports